export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

interface UnitDatum {
  unit: string
  value: number
  name?: string
}

export type UnitData = Record<string, UnitDatum>

export function getUnitData(): UnitData {
  const unitPricesEl = document.getElementById('unit_prices')
  const dataValue = unitPricesEl?.getAttribute('data-value')
  if (!dataValue) {
    return {}
  }
  try {
    return JSON.parse(dataValue)
  } catch {
    return {}
  }
}
